import React from 'react'

const Timeout = () => (
  <div className='col-12 px-0 confirmation-alert py-2 pl-1'>
    <div className='bg-white radius border-brand-1 border-left-lg border-color-brand-1 py-2 px-2'>
      <div className='row align-items-center h-100'>
        <div className='col-auto'>
          <i className='icon icon_clock color-brand-1' />
        </div>
        <div className='col col-md-10'>
          <h2
            id='countDownText'
            className='color-brand-1 txt-circular-book txt-body-lg'
          >
            Tempo esgotado.
          </h2>
        </div>
        <div className='col-auto d-none' />
      </div>
    </div>
  </div>
)

export default Timeout



// WEBPACK FOOTER //
// ./src/features/Checkout/SecondFactorAuthenticaton/Timeout.js